<template>
    <Field :name="name" v-slot="{ field, errors }" v-bind="fieldValidateOn">
        <DateInput
            v-model="field.value"
            @update:modelValue="field['onUpdate:modelValue']"
            @blur="field.onBlur"
            :errorMessages="errors"
            :field-error="!isEmpty(errors)"
            v-bind="input" />
    </Field>
</template>

<script lang="ts">
    import { PropType, ExtractPropTypes, defineComponent, inject } from 'vue';
    import { FieldValidateOn } from '../../Validations/Validations.interfaces';
    import { Field } from 'vee-validate';
    import { isEmpty } from 'lodash';
    import DateInput from './DateInput.vue';

    type DateInputProps = ExtractPropTypes<typeof DateInput.props>;

    export default defineComponent({
        name: 'DateInputField',
        methods: { isEmpty },
        components: { Field, DateInput },
        props: {
            name: {
                type: String,
                required: true,
            },
            input: {
                type: Object as PropType<Partial<DateInputProps>>,
                default: () => ({}),
            },
        },
        setup() {
            const fieldValidateOn = inject('fieldValidateOn') as FieldValidateOn;

            return { fieldValidateOn };
        },
    });
</script>
